import { AxiosResponse } from "axios";
import { syncAmplitudeUserFromApplicationEmail } from "@/services/Amplitude";
import client from "../client";
import { putEditApplicationConfig } from "./PutEditApplicationConfig";
import { putEditApplicationResponse } from "./types";

const putEditApplication = async ({
  applicationId,
  formData,
}: {
  applicationId: string;
  formData: any;
}): Promise<AxiosResponse<putEditApplicationResponse>> => {
  await syncAmplitudeUserFromApplicationEmail(formData);

  return client({
    ...putEditApplicationConfig(applicationId),
    data: { ...formData },
  });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  putEditApplication,
};
